import invariant from 'tiny-invariant';
import isIconOnly from './isIconOnly.js';
export default function validateProps(props) {
    invariant(isIconOnly(props) ? !!props['aria-label'] || !!props['aria-labelledby'] : true, '`aria-label` or `aria-labelledby` is required for icon-only buttons.');
}
//# sourceMappingURL=validateProps.js.map